import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import { parentChainNames } from 'main/hotelBrandsAndChains'
import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

import styles from '../MontlyRevenue.module.scss'
import RadioGroup from '../RadioGroup'
import { dataTypesToShowNames } from '../utils/constants'
import { getBrandDisplayOptions, getGroupDisplayOptions } from '../utils/hotelHelpers'
import YearPicker from '../YearPicker'

export const MonthlyRevenueFilters = ({
  dataToShow,
  setDataToShow,
  isInternalAdmin,
  hotelGroups,
  isDemoMode,
  handleChangeGroupFilter,
  showAllHotels,
  showWholeGroup,
  parentChain,
  setParentChain,
  stateToFilter,
  handleChangeState,
  availableCities,
  cityToFilter,
  setCityToFilter,
  firstYear,
  secondYear,
  minimumAvailableYear,
  setFirstYear,
  setSecondYear
}) => {
  return (
    <div className={styles.topBar}>
      <RadioGroup
        label="Bookings to show"
        options={dataTypesToShowNames}
        value={dataToShow}
        onChange={setDataToShow}
      />
      {isInternalAdmin && (
        <Dropdown
          options={getGroupDisplayOptions(hotelGroups, isDemoMode)}
          defaultValue="currentHotel"
          label="Hotel group & level"
          onChange={e => handleChangeGroupFilter(e.target.value)}
          isDemoMode={isDemoMode}
        />
      )}

      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          options={getBrandDisplayOptions(parentChainNames, isDemoMode)}
          value={parentChain}
          label="Brand"
          onChange={e => setParentChain(e.target.value)}
          isDemoMode={isDemoMode}
        />
      )}
      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          label="State/Province"
          options={{ '': ' Any state', ...usStates, ...canadianProvinces }}
          value={stateToFilter}
          onChange={e => handleChangeState(e.target.value)}
        />
      )}
      {isInternalAdmin && (showAllHotels || showWholeGroup) && (
        <Dropdown
          label="City"
          options={{
            '': ' Any city',
            ...availableCities
          }}
          value={cityToFilter}
          onChange={e => setCityToFilter(e.target.value)}
          defaultValue="Any city"
        />
      )}
      {firstYear && (
        <YearPicker
          firstYear={firstYear}
          secondYear={secondYear}
          minimumAvailableYear={minimumAvailableYear}
          setYears={(firstYear, secondYear) => {
            setFirstYear(firstYear)
            setSecondYear(secondYear)
          }}
        />
      )}
    </div>
  )
}
